var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleGroupFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6,
    r: 3.5,
    fill: "#5FBA9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50002 3.33341C6.11931 3.33341 5.00002 4.4527 5.00002 5.83342C5.00002 7.21413 6.11931 8.33342 7.50002 8.33342C8.88073 8.33342 10 7.21413 10 5.83342C10 4.4527 8.88073 3.33341 7.50002 3.33341ZM3.33335 5.83342C3.33335 3.53223 5.19883 1.66675 7.50002 1.66675C9.80121 1.66675 11.6667 3.53223 11.6667 5.83342C11.6667 8.1346 9.80121 10.0001 7.50002 10.0001C5.19883 10.0001 3.33335 8.1346 3.33335 5.83342Z",
    fill: "#195442"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83335 13.3334C4.45264 13.3334 3.33335 14.4527 3.33335 15.8334V17.5001C3.33335 17.9603 2.96026 18.3334 2.50002 18.3334C2.03978 18.3334 1.66669 17.9603 1.66669 17.5001V15.8334C1.66669 13.5322 3.53217 11.6667 5.83335 11.6667H9.16669C11.4679 11.6667 13.3334 13.5322 13.3334 15.8334V17.5001C13.3334 17.9603 12.9603 18.3334 12.5 18.3334C12.0398 18.3334 11.6667 17.9603 11.6667 17.5001V15.8334C11.6667 14.4527 10.5474 13.3334 9.16669 13.3334H5.83335Z",
    fill: "#195442"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5261 2.40172C12.6402 1.95586 13.0942 1.68697 13.5401 1.80112C15.3837 2.27318 16.6732 3.93445 16.6732 5.83758C16.6732 7.74072 15.3837 9.40199 13.5401 9.87404C13.0942 9.9882 12.6402 9.7193 12.5261 9.27345C12.4119 8.82759 12.6808 8.37361 13.1267 8.25946C14.2329 7.97623 15.0066 6.97946 15.0066 5.83758C15.0066 4.6957 14.2329 3.69894 13.1267 3.41571C12.6808 3.30155 12.4119 2.84757 12.5261 2.40172Z",
    fill: "#195442"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1931 12.4168C14.3082 11.9711 14.7627 11.7032 15.2083 11.8182C17.0394 12.291 18.3225 13.9376 18.3333 15.8286L18.3334 15.8334L18.3334 17.5001C18.3334 17.9603 17.9603 18.3334 17.5 18.3334C17.0398 18.3334 16.6667 17.9603 16.6667 17.5001V15.836C16.6592 14.7023 15.8896 13.7154 14.7917 13.432C14.3461 13.3169 14.0781 12.8624 14.1931 12.4168Z",
    fill: "#195442"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleGroupFillIcon);
export default __webpack_public_path__ + "static/media/people-group-fill-icon.2cd9e7779d6afc31c05d6c00ee5f0c4b.svg";
export { ForwardRef as ReactComponent };